<template>
  <div class="login-root">
    <!-- LEFT PANEL — Animated Scene -->
    <div class="scene-panel">
      <div class="scene-header">
        <div class="logo-mark">
          <svg
width="32"
height="32"
viewBox="0 0 32 32"
fill="none"
>
            <rect
width="32"
height="32"
rx="8"
fill="#fff"
fill-opacity="0.15"
/>
            <path
d="M8 22L12 10L16 18L20 13L24 22H8Z"
fill="white"
opacity="0.9"
/>
          </svg>
        </div>
        <span class="logo-name">GeoProc</span>
      </div>

      <!-- Floating stat cards -->
      <div class="stat-card stat-card--1">
        <div class="stat-icon">
🔐
</div>
        <div>
          <div class="stat-value">
256-bit
</div>
          <div class="stat-label">
Encryption standard
</div>
        </div>
      </div>
      <div class="stat-card stat-card--2">
        <div class="stat-icon">
🛡️
</div>
        <div>
          <div class="stat-value">
99.9%
</div>
          <div class="stat-label">
System uptime
</div>
        </div>
      </div>
      <div class="stat-card stat-card--3">
        <div class="stat-icon">
⚡
</div>
        <div>
          <div class="stat-value">
&lt; 30s
</div>
          <div class="stat-label">
Reset delivery time
</div>
        </div>
      </div>

      <!-- Animated SVG — lock / security theme -->
      <div class="illustration">
        <svg
viewBox="0 0 480 340"
fill="none"
xmlns="http://www.w3.org/2000/svg"
class="scene-svg"
>

          <!-- Ground line -->
          <rect
x="0"
y="290"
width="480"
height="4"
rx="2"
fill="white"
fill-opacity="0.1"
/>

          <!-- Server rack left -->
          <rect
x="30"
y="160"
width="70"
height="130"
rx="4"
fill="white"
fill-opacity="0.07"
stroke="white"
stroke-opacity="0.15"
stroke-width="1.5"
/>
          <rect
x="40"
y="172"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.18"
/>
          <rect
x="40"
y="186"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.12"
/>
          <rect
x="40"
y="200"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.18"
/>
          <rect
x="40"
y="214"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.12"
/>
          <rect
x="40"
y="228"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.18"
/>
          <circle
cx="82"
cy="176"
r="3"
fill="#4ADE80"
fill-opacity="0.8"
class="blink"
/>
          <circle
cx="82"
cy="190"
r="3"
fill="#4ADE80"
fill-opacity="0.8"
class="blink blink--2"
/>
          <circle
cx="82"
cy="204"
r="3"
fill="#FBBF24"
fill-opacity="0.8"
/>
          <circle
cx="82"
cy="218"
r="3"
fill="#4ADE80"
fill-opacity="0.8"
class="blink blink--3"
/>
          <circle
cx="82"
cy="232"
r="3"
fill="#4ADE80"
fill-opacity="0.8"
class="blink"
/>

          <!-- Central lock icon -->
          <g class="lock-float">
            <!-- Lock body -->
            <rect
x="188"
y="165"
width="104"
height="90"
rx="12"
fill="white"
fill-opacity="0.12"
stroke="white"
stroke-opacity="0.3"
stroke-width="2"
/>
            <!-- Lock shackle -->
            <path
d="M212 165 L212 145 Q240 125 268 145 L268 165"
stroke="white"
stroke-opacity="0.5"
stroke-width="3"
stroke-linecap="round"
fill="none"
/>
            <!-- Keyhole circle -->
            <circle
cx="240"
cy="202"
r="14"
fill="white"
fill-opacity="0.2"
stroke="white"
stroke-opacity="0.4"
stroke-width="1.5"
/>
            <!-- Keyhole slot -->
            <rect
x="236"
y="202"
width="8"
height="18"
rx="4"
fill="white"
fill-opacity="0.4"
/>
          </g>

          <!-- Shield behind lock -->
          <g
opacity="0.12"
class="shield-pulse"
>
            <path
d="M240 100 L310 128 L310 190 Q310 240 240 270 Q170 240 170 190 L170 128 Z"
fill="white"
/>
          </g>

          <!-- Server rack right -->
          <rect
x="380"
y="160"
width="70"
height="130"
rx="4"
fill="white"
fill-opacity="0.07"
stroke="white"
stroke-opacity="0.15"
stroke-width="1.5"
/>
          <rect
x="390"
y="172"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.12"
/>
          <rect
x="390"
y="186"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.18"
/>
          <rect
x="390"
y="200"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.12"
/>
          <rect
x="390"
y="214"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.18"
/>
          <rect
x="390"
y="228"
width="50"
height="8"
rx="2"
fill="white"
fill-opacity="0.12"
/>
          <circle
cx="432"
cy="176"
r="3"
fill="#4ADE80"
fill-opacity="0.8"
class="blink blink--2"
/>
          <circle
cx="432"
cy="190"
r="3"
fill="#4ADE80"
fill-opacity="0.8"
class="blink"
/>
          <circle
cx="432"
cy="204"
r="3"
fill="#4ADE80"
fill-opacity="0.8"
class="blink blink--3"
/>
          <circle
cx="432"
cy="218"
r="3"
fill="#FBBF24"
fill-opacity="0.8"
/>
          <circle
cx="432"
cy="232"
r="3"
fill="#4ADE80"
fill-opacity="0.8"
class="blink blink--2"
/>

          <!-- Connection lines from servers to lock -->
          <line
x1="100"
y1="210"
x2="185"
y2="210"
stroke="white"
stroke-opacity="0.2"
stroke-width="1"
stroke-dasharray="5 5"
/>
          <line
x1="295"
y1="210"
x2="380"
y2="210"
stroke="white"
stroke-opacity="0.2"
stroke-width="1"
stroke-dasharray="5 5"
/>

          <!-- Travelling data packet left -->
          <circle
cx="140"
cy="210"
r="4"
fill="#3B82F6"
fill-opacity="0.9"
class="packet-left"
/>
          <!-- Travelling data packet right -->
          <circle
cx="340"
cy="210"
r="4"
fill="#6366F1"
fill-opacity="0.9"
class="packet-right"
/>

          <!-- Email envelope floating -->
          <g class="float-envelope">
            <rect
x="330"
y="38"
width="78"
height="56"
rx="6"
fill="white"
fill-opacity="0.1"
stroke="white"
stroke-opacity="0.25"
stroke-width="1.5"
/>
            <polyline
points="330,44 369,72 408,44"
stroke="white"
stroke-opacity="0.35"
stroke-width="1.5"
fill="none"
/>
            <line
x1="330"
y1="94"
x2="360"
y2="70"
stroke="white"
stroke-opacity="0.2"
stroke-width="1"
/>
            <line
x1="408"
y1="94"
x2="378"
y2="70"
stroke="white"
stroke-opacity="0.2"
stroke-width="1"
/>
          </g>

          <!-- Floating key -->
          <g class="float-key">
            <circle
cx="80"
cy="68"
r="16"
fill="white"
fill-opacity="0.1"
stroke="white"
stroke-opacity="0.3"
stroke-width="1.5"
/>
            <circle
cx="80"
cy="68"
r="8"
fill="none"
stroke="white"
stroke-opacity="0.4"
stroke-width="1.5"
/>
            <rect
x="92"
y="65"
width="24"
height="6"
rx="2"
fill="white"
fill-opacity="0.3"
/>
            <rect
x="110"
y="65"
width="4"
height="10"
rx="1"
fill="white"
fill-opacity="0.3"
/>
            <rect
x="104"
y="65"
width="4"
height="8"
rx="1"
fill="white"
fill-opacity="0.3"
/>
          </g>

          <!-- Network dots -->
          <g opacity="0.3">
            <circle
cx="155"
cy="120"
r="3"
fill="white"
/>
            <circle
cx="200"
cy="90"
r="3"
fill="white"
/>
            <circle
cx="280"
cy="90"
r="3"
fill="white"
/>
            <circle
cx="325"
cy="120"
r="3"
fill="white"
/>
            <line
x1="155"
y1="120"
x2="200"
y2="90"
stroke="white"
stroke-width="1"
stroke-dasharray="3 3"
/>
            <line
x1="200"
y1="90"
x2="280"
y2="90"
stroke="white"
stroke-width="1"
stroke-dasharray="3 3"
/>
            <line
x1="280"
y1="90"
x2="325"
y2="120"
stroke="white"
stroke-width="1"
stroke-dasharray="3 3"
/>
          </g>

          <!-- Ping on lock -->
          <circle
cx="240"
cy="210"
r="14"
fill="white"
class="ping"
/>

        </svg>
      </div>

      <div class="scene-footer">
        <p class="tagline">
Your account is safe.<br>Reset takes less than a minute.
</p>
      </div>

      <div class="orb orb--1" />
      <div class="orb orb--2" />
    </div>

    <!-- RIGHT PANEL — Forgot Password Form -->
    <div class="form-panel">
      <div class="form-inner">

        <div class="form-logo">
          <b-img
:src="geolimLogo"
alt="Geolim Logo"
height="48"
width="48"
/>
        </div>

        <div class="form-eyebrow">
PT GEOSERVICES
</div>
        <h1 class="form-title">
Forgot password?
</h1>
        <p class="form-sub">
Enter your username and we'll send you a new password.
</p>

        <validation-observer ref="simpleRules">
          <b-form
class="login-form"
@submit.prevent="validationForm"
>

            <b-form-group
label="Username / Email"
label-for="forgot-password-email"
class="field-group"
>
              <validation-provider
#default="{ errors }"
name="Email"
rules="required|email"
>
                <b-form-input
                  id="forgot-password-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false : null"
                  name="forgot-password-email"
                  placeholder="your.username"
                  class="custom-input"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-button
type="submit"
block
class="signin-btn"
>
              <span>Send reset link</span>
              <feather-icon
icon="SendIcon"
size="16"
/>
            </b-button>

          </b-form>
        </validation-observer>

        <div class="back-link-wrap">
          <b-link
:to="{name:'auth-login'}"
class="back-link"
>
            <feather-icon
icon="ChevronLeftIcon"
size="14"
/>
            Back to sign in
          </b-link>
        </div>

        <p class="form-version">
GeoProc v2.0 &nbsp;·&nbsp; PT Geoservices
</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import axios from 'axios'
import moment from 'moment-timezone'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BRow,
BCol,
BLink,
BImg,
BForm,
BButton,
BFormGroup,
BFormInput,
    BCardTitle,
BCardText,
ValidationProvider,
ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      geolimLogo: require('@/assets/images/logo/geolim.png'),
      required,
      email,
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) return
        const payload = { username: this.userEmail, time: moment() }
        const headers = { 'Content-Type': 'application/json' }
        axios
          .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_RESET_PASSWORD_URL}`, payload, { headers })
          .then(response => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Notification',
                icon: 'BellIcon',
                variant: response.data.success === true ? 'success' : 'danger',
                text: response.data.message,
              },
            })
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
 title: 'Notification', icon: 'BellIcon', variant: 'danger', text: 'Terjadi kesalahan',
},
            })
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$accent:   #3B82F6;
$accent2:  #6366F1;
$dark:     #0F172A;
$darker:   #080E1C;
$surface:  #151E2E;
$border:   rgba(255,255,255,0.08);
$text-dim: rgba(255,255,255,0.45);

.login-root {
  display: flex;
  min-height: 100vh;
  background: $darker;
  font-family: 'DM Sans', 'Segoe UI', sans-serif;
}

// ── LEFT panel ───────────────────────────────────────────────────────
.scene-panel {
  position: relative;
  flex: 1;
  display: none;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(135deg, #0F2855 0%, #0a1628 60%, #0d1f3c 100%);
  padding: 2.5rem;
  @media (min-width: 992px) { display: flex; }
}

.scene-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  z-index: 2;
}
.logo-name {
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.stat-card {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(255,255,255,0.07);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px;
  padding: 0.75rem 1rem;
  z-index: 3;
  animation: floatCard 6s ease-in-out infinite;
  .stat-icon  { font-size: 1.4rem; }
  .stat-value { color: white; font-weight: 700; font-size: 1rem; line-height: 1.2; }
  .stat-label { color: $text-dim; font-size: 0.7rem; }
  &--1 { top: 18%; left: 6%;  animation-delay: 0s; }
  &--2 { top: 34%; right: 8%; animation-delay: 2s; }
  &--3 { top: 52%; left: 10%; animation-delay: 4s; }
}

@keyframes floatCard {
  0%, 100% { transform: translateY(0px); }
  50%       { transform: translateY(-8px); }
}

.illustration {
  position: absolute;
  bottom: 110px;
  left: 0; right: 0;
  display: flex;
  justify-content: center;
  z-index: 2;
}
.scene-svg { width: 100%; max-width: 520px; }

// SVG animations
.lock-float {
  animation: lockFloat 4s ease-in-out infinite;
}
@keyframes lockFloat {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-10px); }
}

.shield-pulse {
  animation: shieldPulse 3s ease-in-out infinite;
}
@keyframes shieldPulse {
  0%, 100% { opacity: 0.08; }
  50%       { opacity: 0.18; }
}

.float-envelope {
  animation: floatEnv 5s ease-in-out infinite;
}
@keyframes floatEnv {
  0%, 100% { transform: translateY(0) rotate(-3deg); }
  50%       { transform: translateY(-12px) rotate(2deg); }
}

.float-key {
  animation: floatKey 6s ease-in-out infinite reverse;
}
@keyframes floatKey {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50%       { transform: translateY(-8px) rotate(8deg); }
}

.blink { animation: blink 2s ease-in-out infinite; }
.blink--2 { animation-delay: 0.7s; }
.blink--3 { animation-delay: 1.4s; }
@keyframes blink {
  0%, 100% { opacity: 0.8; }
  50%       { opacity: 0.2; }
}

.packet-left {
  animation: packetLeft 2.5s linear infinite;
}
@keyframes packetLeft {
  0%   { transform: translateX(0);   opacity: 1; }
  90%  { transform: translateX(80px); opacity: 1; }
  100% { transform: translateX(80px); opacity: 0; }
}

.packet-right {
  animation: packetRight 2.5s linear infinite 1.2s;
}
@keyframes packetRight {
  0%   { transform: translateX(0);    opacity: 1; }
  90%  { transform: translateX(-80px); opacity: 1; }
  100% { transform: translateX(-80px); opacity: 0; }
}

.ping {
  animation: ping 2.5s ease-out infinite;
  transform-origin: 240px 210px;
}
@keyframes ping {
  0%   { r: 14; opacity: 0.6; }
  100% { r: 40; opacity: 0;   }
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
}
.orb--1 {
  width: 360px; height: 360px;
  background: radial-gradient(circle, rgba(59,130,246,0.25) 0%, transparent 70%);
  top: -80px; left: -80px;
  animation: orbPulse 8s ease-in-out infinite;
}
.orb--2 {
  width: 280px; height: 280px;
  background: radial-gradient(circle, rgba(99,102,241,0.2) 0%, transparent 70%);
  bottom: 60px; right: -60px;
  animation: orbPulse 10s ease-in-out infinite reverse;
}
@keyframes orbPulse {
  0%, 100% { opacity: 0.7; transform: scale(1); }
  50%       { opacity: 1;   transform: scale(1.1); }
}

.scene-footer {
  position: absolute;
  bottom: 2.5rem; left: 2.5rem;
  z-index: 3;
}
.tagline {
  color: rgba(255,255,255,0.55);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

// ── RIGHT panel ───────────────────────────────────────────────────────
.form-panel {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $dark;
  padding: 2rem;
  @media (min-width: 992px) {
    width: 420px;
    flex-shrink: 0;
    border-left: 1px solid $border;
  }
}

.form-inner {
  width: 100%;
  max-width: 340px;
}

.form-logo {
  margin-bottom: 1.25rem;
  img { border-radius: 10px; }
}

.form-eyebrow {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: $accent;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.form-title {
  color: white;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.35rem;
  line-height: 1.2;
}

.form-sub {
  color: $text-dim;
  font-size: 0.875rem;
  margin-bottom: 2.25rem;
}

.field-group {
  margin-bottom: 1.25rem;
  ::v-deep label {
    color: rgba(255,255,255,0.65);
    font-size: 0.78rem;
    font-weight: 500;
    letter-spacing: 0.03em;
    margin-bottom: 0.4rem;
  }
}

.custom-input {
  background: $surface !important;
  border: 1px solid $border !important;
  border-radius: 8px !important;
  color: white !important;
  padding: 0.65rem 0.85rem !important;
  font-size: 0.9rem !important;
  transition: border-color 0.2s, background-color 0.2s !important;
  &::placeholder { color: rgba(255,255,255,0.25) !important; }
  &:focus {
    border-color: $accent !important;
    box-shadow: none !important;
    background: $surface !important;
    transform: none !important;
  }
}

.signin-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, $accent 0%, $accent2 100%) !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 0.75rem !important;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  color: white !important;
  letter-spacing: 0.02em;
  transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s !important;
  box-shadow: 0 4px 20px rgba(59,130,246,0.35) !important;
  margin-bottom: 1.5rem;
  &:hover {
    opacity: 0.92;
    transform: translateY(-1px);
    box-shadow: 0 6px 28px rgba(59,130,246,0.45) !important;
  }
  &:active { transform: translateY(0); }
}

.back-link-wrap {
  text-align: center;
}
.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: $accent;
  font-size: 0.85rem;
  text-decoration: none;
  &:hover { color: lighten(#3B82F6, 10%); }
}

.form-version {
  color: rgba(255,255,255,0.2);
  font-size: 0.7rem;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 0;
}
</style>
